module.exports = {"new":"Novinka","unavailable":"Nedostupné","noHistorySubtitle":"záznamov","historySubtitle":"aktívne/vr. histórie"}